<template>
    <div class="block">

        <div class="flex justify-center mb-1">
            <div class="text-xs text-gray-500 mr-2">Pack Size: {{ unit ? product.units[unit].pack_size : product.units[product.default_selling_unit].pack_size }}</div>
        </div>
        <div class="flex justify-center">

            <select :disabled="!enableProductUnitSelection" id="unit" v-model="unit" :key="`unit-${product.id}`"
                    class="mx-1 form-select block w-20 rounded transition ease-in-out duration-150 text-xs"
                    name="unit">
                <option v-for="(unit) in product.units_available" :value="unit.key">{{ unit.label }}</option>
            </select>
            <div class="flex flex-row mx-1">
                <button @click="deductQty"
                        class="-mr-px relative inline-flex items-center px-2.5 py-1 border border-gray-300 text-sm leading-4 font-medium rounded-l-md text-gray-700 bg-gray-50 hover:text-gray-500 hover:bg-white active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150">
                    -
                </button>
                <div class="relative flex-grow focus-within:z-10">
                    <input type="number" ref="qty" v-model.number="qty" @change="sync" id="qt"
                           class="form-input number-no-spin mx-0 text-center w-16 text-xs rounded-none transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                           placeholder="qty"/>
                </div>
                <button @click="addQty"
                        class="-ml-px relative inline-flex items-center px-2.5 py-1 border border-gray-300 text-xs leading-4 font-medium rounded-r-md text-gray-700 bg-gray-50 hover:text-gray-500 hover:bg-white active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150">
                    +
                </button>
            </div>
        </div>
    </div>
</template>
<script>
  import store from './store.js'
  export default {
    name: 'ProductControl',
    props: {
      product: {},
      quantityAdded: {
        type: Function
      },
      enableProductUnitSelection: Boolean,
    },

    watch: {
      // qtyAdded(val) {
      //   this.qty = val
      // }

      'unit': {
        handler: function (val) {
          if(val) {
            this.$emit('unitChange', val)
          }
        }
      },

      'item.qty': {
        handler: function (val) {
          if (val) {
            // console.log('change', val)
            this.qty = val
          } else {
            this.qty = 0
          }
        },
      }
    },

    data() {
      return {
        qty: 0,
        unit: this.product.default_selling_unit,
        item_code: this.product.item_code
      }
    },

    mounted() {
      this.qty = this.getInitialQty()
    },

    methods: {
      sync() {
        let qty = Math.round(this.qty)
        this.qty = qty;
        store.updateQty({qty: this.qty, unit: this.unit, item_code: this.item_code, product: this.product})
        this.qty = store.qtyForItemUnit(this.item_code, this.unit)
      },

      deductQty(){
        if (this.qty > 0) {
            this.qty--;
          this.sync()
        }
      },

      addQty() {
        this.qty++;
        this.sync()
      },

      getInitialQty() {
        if(this.item) {
          if(this.item.qty > 0) {
            return this.item.qty
          }
        }

        return 0
      }
    },

    computed: {

      item() {
        let item = store.form.items.find(itm => itm.item_code === this.product.item_code && itm.unit == this.unit)

        return item;
      },

      qtyAdded() {
        let item = store.form.items.find(itm => itm.item_code === this.product.item_code && itm.unit == this.unit)

        if (item) {
          return item.qty;
        } else {
          return 0
        }
      }
    }
  }
</script>
